// extracted by mini-css-extract-plugin
export default {"reactMarkDown":"About_reactMarkDown__ov7BS"};